import { IOffer } from '../types/offer';

export const prepareIds = (offers: IOffer[] | null) => {
  if (!offers) {
    return [];
  }

  return offers.map(({ id }) => id);
};
